import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  Row,
  Spinner,
} from "reactstrap";
import React, { useEffect, useState } from "react";
import planChecked from "../../assets/img/icons/user/plan-checked.png";
import {
  collection,
  doc,
  getDocs,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import {
  createUserWithEmailAndPassword,
  getAuth,
  sendEmailVerification,
} from "firebase/auth";
import { getDb, trackGA4Event } from "util/Constants";
import { Link, useHistory, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import countries from "./../../util/Countries.json";
import Select from "react-select";
import { NotificationManager } from "react-notifications";
import ReactGA from "react-ga4";

ReactGA.initialize("G-FJ1HM8S5ZX");
const Register = (props) => {
  const [user, setUser] = useState({
    email: "",
    password: "",
    companyName: "",
    jobTitle: "",
  });
  const [ready, setReady] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const plan = queryParams.get("plan");
  const history = useHistory();
  const auth = getAuth();
  const isProgress = props.metadata.environment === "progress";

  // trackGA4Event("Verification email Sent", "", props.metadata.environment);
  useEffect(() => {
    if (user.password !== confirmPassword) {
      setReady(true);
    } else {
      setReady(false);
    }
  }, [confirmPassword, user]);


useEffect(()=>{
    if(auth.currentUser){
        console.log(auth.currentUser);
        if(!auth.currentUser.emailVerified){
            Swal.fire({
                title: "Please verify your email",
                text: "Kindly verify the email to proceed",
                icon: "warning",
                allowOutsideClick: false,
              }).then((result) => {
                window.location.reload();
              });
        }
    }
},[])



  const signUp = async (e) => {
    e.preventDefault();
    setLoading(true);
    const auth = getAuth();
    const { email, password, companyName } = user;
    const adminRef = collection(getDb(), "admins");
    const adminQuery = query(
      adminRef,
      where("companyKey", "==", companyName.toLowerCase().replace(/\s/g, ""))
    );
    const adminSnapshot = await getDocs(adminQuery);
    if (user.password !== confirmPassword) {
      NotificationManager.error("Password do not match");
      setLoading(false);
      return;
    }
    if (adminSnapshot.size > 0) {
      setLoading(false);
      return Swal.fire({
        title: "Error!",
        text: "Company already registered",
        icon: "error",
      });
    } else {
      let maxUsers = 0;
      let maxAssessments = 0;
      let expiry = 0;
      let userPlan = "";
      if (
        (plan === "free" && props.metadata.environment === "ace") ||
        isProgress
      ) {
        maxAssessments = 1;
        maxUsers = 15;
        userPlan = "free";
        expiry = null;
      } else {
        //     write a query to firebase collection to get the plan details based on userId
        //     maxUsers = 15;
        //     maxAssesments = 1;
        const paymentsRef = collection(getDb(), "payments");
        const q = query(paymentsRef, where("email", "==", email));
        const snapshot = await getDocs(q);

        if (snapshot.size > 0) {
          snapshot.forEach((doc) => {
            maxUsers = doc.data().maxUsers;
            maxAssessments = doc.data().maxAssessments;
            expiry = doc.data().subscription.nextPaymentDate * 1000;
            if (maxAssessments === 1) {
              userPlan = "standard";
            } else {
              userPlan = "premium";
            }
          });
        } else {
          setLoading(false);
          return Swal.fire({
            title: "Error!",
            text: "You have not purchased any plan",
            icon: "error",
          });
        }
      }
      createUserWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
          const user = userCredential.user;
          const actionCodeSettings = {
            url: window.location.origin,
          };
          // Send verification email
          return sendEmailVerification(user, actionCodeSettings).then(() => {
            setUser({
              email: "",
              password: "",
              companyName: "",
              jobTitle: "",
              name: "",
            });
            setConfirmPassword("");
            trackGA4Event(
              "Verification email Sent",
              "",
              props.metadata.environment
            );
            Swal.fire({
              title: "Verification Email sent",
              text: "Verification email sent, Kindly check the email to proceed",
              icon: "success",
              allowOutsideClick: false,
            }).then((result) => {
              window.location.reload();
            });
            return user;
          });
        })
        .catch((error) => {
         console.log(error.code)
          if (error.code === "auth/email-already-in-use")
            NotificationManager.error("Email already exists");
          else if (error.code === "auth/weak-password")
            NotificationManager.error("Password must be 6 digit long");
          else NotificationManager.error("Password/Email Incorrect");

          setLoading(false);
          return error.message;
        })
        .then((u) => {
          const docRef = doc(getDb(), "admins", u.uid);
          const data = {
            email: user.email,
            name: user.name,
            country: user.country,
            emailVerifired: false,
            role: "admin",
            active: true,
            jobTitle: user.jobTitle,
            companyName: user.companyName.replace(/\./g, "_"),
            usersCount: 0,
            assessmentsCount: 0,
            maxAssessments: maxAssessments,
            maxUsers: maxUsers,
            newUser: true,
            plan: userPlan,
            expiry: expiry,
            projectType: props.metadata.environment,
            companyKey: user.companyName
              .toLowerCase()
              .replace(/\s/g, "")
              .replace(/\./g, "_"),
          };
          console.log(data);
          setDoc(docRef, data)
            .then(() => {
              const eventPayload =
                "name=" +
                user.name +
                "&email=" +
                user.email +
                "&companyName=" +
                user.companyName;

              trackGA4Event(
                "User SignUp",
                eventPayload,
                props.metadata.environment
              );
              setLoading(false);
            })
            .catch((error) => {
              console.error("Error writing document: ", error);
              setLoading(false);
            });
        });
    }
    // setLoading(false);
    // return ;
  };

  return (
    <>
      <Col lg="12" md="12">
        {/*<div className="d-flex justify-content-between">*/}
        <Row className={"d-flex justify-content-center"}>
          {plan === "free" && !isProgress ? (
            <>
              <Col sm={12} lg={6}>
                <Card className="p-lg-4 plan-card br-15">
                  <CardBody className="">
                    {/*<Container>*/}
                    <div className="text-center">
                      <h1 className="plan-heading">Free Plan</h1>
                      <label className="plan-sub-heading">
                        Your plan comes with:
                      </label>
                    </div>
                    <div>
                      <div className="plan-item d-flex align-items-center">
                        <img src={planChecked} height={19} />
                        <span className="text-dark font-weight-bold ml-3">
                          15 Candidate Assessments
                        </span>
                      </div>
                      <div className="plan-item d-flex align-items-center">
                        <img src={planChecked} height={19} />
                        <span className="text-dark font-weight-bold ml-3">
                          1 Assessment Game
                        </span>
                      </div>
                      <div className="plan-item d-flex align-items-center">
                        <img src={planChecked} height={19} />
                        <span className="text-dark font-weight-bold ml-3">
                          Single User Invite
                        </span>
                      </div>
                      <div className="plan-item d-flex align-items-center">
                        <img src={planChecked} height={19} />
                        <span className="text-dark font-weight-bold ml-3">
                          Fixed Competencies
                        </span>
                      </div>
                      <div className="plan-item d-flex align-items-center">
                        <img src={planChecked} height={19} />
                        <span className="text-dark font-weight-bold ml-3">
                          Reports
                        </span>
                      </div>
                    </div>
                    {/*</Container>*/}
                  </CardBody>
                </Card>
              </Col>
            </>
          ) : null}

          <Col sm={12} lg={6}>
            <Card className="pt-lg-4 px-lg-2 pb-5 br-15">
              <CardBody className="">
                <Form onSubmit={signUp}>
                  <h1 className="text-center text-dark">Welcome</h1>
                  <div className="">
                    <Row>
                      <Col lg={6} sm={12}>
                        <div className="">
                          {/*<FormLabel className="small font-weight-bold text-dark ml-3">Your Full Name*</FormLabel>*/}
                          <Input
                            placeholder="Full Name"
                            className="assessment-input mt-0"
                            type="text"
                            disabled={loading}
                            maxLength={250}
                            autoComplete="new-email"
                            value={user.name}
                            required
                            onChange={(e) =>
                              setUser({ ...user, name: e.target.value })
                            }
                          />
                          <label className="fs-14 ml-2 font-weight-600">
                            Your Full Name*
                          </label>
                        </div>
                      </Col>
                      <Col lg={6} sm={12}>
                        <div className="">
                          {/*<FormLabel className="small font-weight-bold text-dark ml-3">Job*/}
                          {/*    Title*</FormLabel>*/}
                          <Input
                            placeholder="Job Title"
                            className="assessment-input mt-0"
                            type="text"
                            maxLength={250}
                            disabled={loading}
                            value={user.jobTitle}
                            required
                            onChange={(e) =>
                              setUser({ ...user, jobTitle: e.target.value })
                            }
                          />
                          <label className="fs-14 ml-2 font-weight-600">
                            Job Title*
                          </label>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} sm={12}>
                        <div className="">
                          {/*<FormLabel className="small font-weight-bold text-dark ml-3">Work*/}
                          {/*    Email*</FormLabel>*/}
                          <Input
                            placeholder="Work Email"
                            className="assessment-input mt-0"
                            type="email"
                            maxLength={250}
                            disabled={loading}
                            autoComplete="new-email"
                            value={user.email}
                            required
                            onChange={(e) =>
                              setUser({ ...user, email: e.target.value })
                            }
                          />
                          <label className="fs-14 ml-2 font-weight-600">
                            Work Email*
                          </label>
                        </div>
                      </Col>
                      <Col lg={6} sm={12}>
                        <div className="">
                          {/*<FormLabel className="small font-weight-bold text-dark ml-3">Company*/}
                          {/*    Name*</FormLabel>*/}
                          <Input
                            placeholder="Company"
                            className="assessment-input mt-0"
                            type="text"
                            maxLength={250}
                            autoComplete="new-email"
                            value={user.companyName}
                            disabled={loading}
                            required
                            onChange={(e) =>
                              setUser({
                                ...user,
                                companyName: e.target.value,
                              })
                            }
                          />
                          <label className="fs-14 ml-2 font-weight-600">
                            Company Name*
                          </label>
                        </div>
                      </Col>
                    </Row>
                    <div className="">
                      {/*<FormLabel*/}
                      {/*    className="small font-weight-bold text-dark ml-3">Country*</FormLabel>*/}
                      <Select
                        placeholder="Country"
                        options={countries}
                        disabled={loading}
                        required
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            // backgroundColor: "#f4f6f8",
                            // border: "none",
                            // borderRadius: "10px",
                            // color: "#8898aa",
                            background: "transparent",
                            borderLeft: "none",
                            borderRight: "none",
                            borderTop: "none",
                            borderRadius: 0,
                          }),
                          singleValue: (base, state) => ({
                            ...base,
                            color: "#8898aa",
                          }),
                        }}
                        onChange={(selectedOption) =>
                          setUser({
                            ...user,
                            country: selectedOption.value,
                          })
                        }
                      ></Select>
                      <label className="fs-14 ml-2 font-weight-600">
                        Country*
                      </label>
                    </div>
                    <Row>
                      <Col lg={6} sm={12}>
                        <div className="">
                          {/*<FormLabel className="small font-weight-bold text-dark ml-3">Password*/}
                          {/*    *</FormLabel>*/}
                          <Input
                            placeholder="Password"
                            className="assessment-input mt-0"
                            maxLength={250}
                            value={user.password}
                            disabled={loading}
                            type="password"
                            required
                            onChange={(e) =>
                              setUser({ ...user, password: e.target.value })
                            }
                          />
                          <label className="fs-14 ml-2 font-weight-600">
                            Password*
                          </label>
                        </div>
                      </Col>
                      <Col lg={6} sm={12}>
                        <div className="">
                          {/*<FormLabel className="small font-weight-bold text-dark ml-3">Confirm*/}
                          {/*    Password*</FormLabel>*/}
                          <Input
                            placeholder="Confirm Password"
                            className="assessment-input mt-0"
                            maxLength={250}
                            type="password"
                            value={confirmPassword}
                            disabled={loading}
                            valid={
                              user.password === confirmPassword &&
                              confirmPassword !== ""
                            }
                            invalid={
                              user.password !== confirmPassword &&
                              confirmPassword !== ""
                            }
                            required
                            onChange={(e) => {
                              // e.target.value === user.password ? setReady(true) : setReady(false);
                              setConfirmPassword(e.target.value);
                            }}
                          />
                          <label className="fs-14 ml-2 font-weight-600">
                            Confirm Password*
                          </label>
                        </div>
                      </Col>
                    </Row>
                    {/*<Row className="mt-3">*/}
                    {/*    <Col md={12} className={"text-center"}>*/}
                    {/*        {*/}
                    {/*            user.password && confirmPassword && user.password !== confirmPassword*/}
                    {/*            &&*/}
                    {/*            <span className={"text-danger"}>*/}
                    {/*                Passwords do not match*/}
                    {/*            </span>*/}
                    {/*        }*/}
                    {/*    </Col>*/}
                    {/*</Row>*/}
                    <Container>
                      <div className="mb-1">
                        <input
                          className="auth-checkbox"
                          type="checkbox"
                          required
                        />
                        <span className="ml-2 fs-14 font-weight-600 text-dark">
                          I agree to the{" "}
                          {isProgress ? "Progress " : "Ace Assessment"}
                          <a
                            className="link-color"
                            href="https://activ8games.com/terms.html"
                            target="_blank"
                          >
                            {" "}
                            Terms of Services{" "}
                          </a>
                          &
                          <a
                            className="link-color"
                            href="https://activ8games.com/privacy.html"
                            target="_blank"
                          >
                            {" "}
                            Privacy Policy
                          </a>
                        </span>
                      </div>
                    </Container>
                    <div>
                      <Button
                        type="submit"
                        color=""
                        className="footerButton text-white w-100"
                      >
                        {loading ? (
                          <Spinner color="white" size="sm" className="mx-3">
                            Loading..
                          </Spinner>
                        ) : (
                          "Register Account"
                        )}
                      </Button>
                      <div className="text-center mt-2 mb-2">
                        <span>
                          Already have an account?{" "}
                          <Link to="/auth/login" className="text-underline">
                            Login
                          </Link>
                        </span>
                      </div>
                    </div>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {/*</div>*/}
      </Col>
    </>
  );
};

export default Register;
